<!--
 * @Author: gongzhichao
 * @Date: 2023-04-14 00:00:00
 * @LastEditors: gongzhichao 18311120024@163.com
 * @Description: 页面入口文件(主组件)
-->
<template>
  <div id="app">
    <div class="loading" v-if="$utils.isClientType() == 'pc' && loading">
      <img
        class="loading-img"
        src="./assets/image/pc/gif-jz.gif"
        fetchpriority="high"
        alt=""
      />
      <div class="loader"></div>
    </div>
    <router-view v-else />
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
    };
  },
  created() {
    window.addEventListener("load", this.pageLoading, true);
  },
  methods: {
    pageLoading() {
      this.loading = false;
    },
  },
};
</script>
<style lang="scss">
.loading {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1920px;
  height: 100vh;
  // position: absolute;
  z-index: 9999;
  // background: url("~@/assets/image/pc/basemap-loading.jpg") no-repeat center;
  // background-size: 100% 100%;
  /* HTML: <div class="loader"></div> */
  .loading-img {
    position: absolute;
  }
  .loader {
    width: 30px;
    height: 30px;
    // aspect-ratio: 1;
    --b: 3px;
    border-radius: 50%;
    padding: 1px;
    background: conic-gradient(#0000 10%, #ffffff) content-box;

    -webkit-mask: repeating-conic-gradient(
        #0000 0deg,
        #000 1deg 20deg,
        #0000 21deg 36deg
      ),
      radial-gradient(
        farthest-side,
        #0000 calc(100% - var(--b) - 1px),
        #000 calc(100% - var(--b))
      );
    -webkit-mask-composite: destination-in;

    mask-composite: intersect;
    animation: l4 1s infinite steps(10);
  }
  @keyframes l4 {
    to {
      transform: rotate(1turn);
    }
  }
}
* {
  padding: 0;
  margin: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  // font-family: "宋体", SimSun, serif;
  // font-family: "微软雅黑", Arial, Helvetica, sans-serif;
  // font-family: '字体一';
}
#app {
  display: flex;
  justify-content: center;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
}

li {
  list-style: none;
}
@media screen and (max-width: 600px) {
  #app {
    width: 100%;
    display: flex;
    justify-content: center;
    height: auto;
    margin: 0 auto;
    overflow: hidden;
  }
}
// @media screen and (min-width: 1280px)
@media only screen and (min-width: 1280px) and (max-width: 1920px) {
  #app {
    min-width: 1920px;
    display: flex;
    justify-content: center;
    height: auto;
    margin: 0 auto;
    overflow: hidden;
  }
}
/*定义滚动条高宽及背景
 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 1.5px;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.2);
}

/*定义滚动条轨道
 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
/*定义滑块
     内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #b3b3b3;
}
.messageIndex {
  z-index: 10005 !important;
}
</style>
